
import { Poll, PollOption } from '@/types/group';

export const calculateTotalVotes = (poll: Poll): number => {
  return poll.options?.reduce((sum, option) => sum + (option.vote_count || 0), 0) || 0;
};

export const calculatePercentage = (voteCount: number, totalVotes: number): number => {
  return totalVotes > 0 ? Math.round((voteCount / totalVotes) * 100) : 0;
};

export const hasUserVoted = (poll: Poll, userId: string | undefined): boolean => {
  return !!poll.options?.some(option => 
    option.votes?.some(vote => vote.user_id === userId)
  );
};

export const getUserVotedOption = (poll: Poll, userId: string | undefined): PollOption | undefined => {
  return poll.options?.find(option => 
    option.votes?.some(vote => vote.user_id === userId)
  );
};

export const isUserVoteForOption = (option: PollOption, userId: string | undefined): boolean => {
  return !!option.votes?.some(vote => vote.user_id === userId);
};
